import React from "react";
import { ArrowRight, Phone, Star } from "lucide-react";
import { HERO_VAN_URL } from "@/i18n";

export default function Hero({ t, contact }) {
  return (
    <section id="top" className="relative bg-white border-b-2 border-black overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20 pb-16 md:pb-24 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 flex flex-col justify-center fade-up">
          <div className="inline-flex items-center gap-2 text-[11px] md:text-xs font-bold tracking-[0.22em] text-[#E11D2E] mb-5">
            <span className="inline-block w-6 h-[2px] bg-[#E11D2E]" />
            {t.hero.eyebrow}
          </div>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-[7.2vw] leading-[0.88]">
            {t.hero.title_1}
            <br />
            <span className="text-[#E11D2E]">{t.hero.title_2}</span>
          </h1>
          <p className="mt-6 md:mt-8 text-base md:text-lg text-zinc-700 max-w-xl leading-relaxed">
            {t.hero.subtitle}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3 md:gap-4">
            <a
              href="#quote"
              className="inline-flex items-center gap-2 bg-[#E11D2E] text-white px-6 md:px-7 py-3.5 font-bold uppercase tracking-wider text-sm border-2 border-black brutal-shadow"
              data-testid="hero-cta-quote"
            >
              {t.hero.cta_primary} <ArrowRight size={18} />
            </a>
            <a
              href={`tel:${contact.phone_tel}`}
              className="inline-flex items-center gap-2 bg-white text-black px-6 md:px-7 py-3.5 font-bold uppercase tracking-wider text-sm border-2 border-black brutal-shadow"
              data-testid="hero-cta-call"
            >
              <Phone size={18} /> {t.hero.cta_secondary}
            </a>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-xl">
            {[
              { k: t.hero.stat_1_k, v: t.hero.stat_1_v },
              { k: t.hero.stat_2_k, v: t.hero.stat_2_v },
              { k: t.hero.stat_3_k, v: t.hero.stat_3_v },
            ].map((s, i) => (
              <div key={i} className="border-2 border-black p-3 md:p-4" data-testid={`hero-stat-${i}`}>
                <div className="font-display text-2xl md:text-3xl">{s.k}</div>
                <div className="text-[11px] md:text-xs text-zinc-600 mt-1 leading-tight">{s.v}</div>
              </div>
            ))}
          </div>

          <div className="mt-7 flex items-center gap-2" data-testid="hero-rating">
            <div className="flex">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star key={i} size={18} fill="#E11D2E" className="text-[#E11D2E]" strokeWidth={0} />
              ))}
            </div>
            <span className="text-sm font-semibold">4.9/5</span>
            <span className="text-sm text-zinc-500">· 380+</span>
          </div>
        </div>

        <div className="lg:col-span-5 relative fade-up delay-2">
          <div className="relative border-2 border-black bg-zinc-100 overflow-hidden h-[340px] md:h-[480px] lg:h-full min-h-[420px] brutal-shadow-red">
            <img
              src={HERO_VAN_URL}
              alt="Mercedes Sprinter van"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-black text-white p-4 md:p-5 border-t-2 border-[#E11D2E]">
              <div className="text-[10px] tracking-[0.22em] text-[#E11D2E] font-bold">FLEET</div>
              <div className="font-display text-xl md:text-2xl mt-1">Mercedes Sprinter · 17 m³</div>
              <div className="text-xs text-zinc-300 mt-1">Forsikret · GPS-sporet · Klimakontroll</div>
            </div>
            <div className="absolute top-4 right-4 bg-[#E11D2E] text-white font-display text-2xl px-3 py-2 border-2 border-black">
              RASKT
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
